import { authmodul_user_data_reducers } from "../reducers/userAuthReducers";

const modulAuth = {
  authmodul_user_data: authmodul_user_data_reducers,
};

export default modulAuth;
